"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextSubscriber = void 0;

var react_1 = __importStar(require("react"));

var subscription_1 = require("./subscription");

var hook_1 = require("./hook");

var EMPTY_VAL = "__$$emptyValue:-r$H5*AUg&TPWUkH_fPbLLNJQfHF4WQ%&rey)qCJP+]83~J^v__$$";

var ContextSubscriber =
/** @class */
function () {
  function ContextSubscriber(defaultValueGetter, equalityFn) {
    var _this = this;

    if (defaultValueGetter === void 0) {
      defaultValueGetter = function defaultValueGetter() {
        return EMPTY_VAL;
      };
    }

    if (equalityFn === void 0) {
      equalityFn = defaultShallowEquality;
    }

    this.defaultValueGetter = defaultValueGetter;
    this.equalityFn = equalityFn;

    this.useGettingDefaultValue = function () {
      var value = _this.defaultValueGetter();

      if (value === EMPTY_VAL) {
        throw new Error("Cannot use ContextSubscriber without default value or provider");
      }

      _this.updateLastProviderValue.apply(_this, __spreadArrays([_this.defaultProvider.id], value));
    };

    this.counter = 0;
    this.lastValuesByProviderIds = {};
    this.subscriptionsByProviderIds = {};

    this.updateLastProviderValue = function (id) {
      var _a;

      var value = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        value[_i - 1] = arguments[_i];
      }

      var isInitialCall = !_this.lastValuesByProviderIds.hasOwnProperty(id);
      var oldValue = _this.lastValuesByProviderIds[id];
      _this.lastValuesByProviderIds[id] = value;

      if (!isInitialCall && !_this.equalityFn(oldValue, value)) {
        (_a = _this.subscriptionsByProviderIds[id]).broadcast.apply(_a, value);
      }
    };

    this.destroyIntervalProvider = function (id) {
      setTimeout(function () {
        delete _this.lastValuesByProviderIds[id];
      }, 1);
    };

    this.registerNewProvider = function () {
      _this.counter++;
      var id = _this.counter;
      var subscription = new subscription_1.Subscription();
      _this.subscriptionsByProviderIds[id] = subscription;
      return {
        id: id,
        getLatestValue: function getLatestValue() {
          return _this.getValue(id);
        },
        subscribe: subscription.subscribe,
        asyncReverseOrderSubscribe: subscription.asyncReverseOrderSubscribe
      };
    };

    this.getValue = function (id) {
      if (!_this.lastValuesByProviderIds.hasOwnProperty(id)) {
        throw new Error("context is not initialized yet");
      }

      var data = _this.lastValuesByProviderIds[id];
      return data;
    };

    this.hook = function () {
      return react_1.useContext(_this.context);
    };

    this.defaultProvider = this.registerNewProvider();
    this.context = react_1.default.createContext(this.defaultProvider);
    this.useSelector = hook_1.createContextSelectorHook(this.context, this.defaultProvider.id, this.useGettingDefaultValue);
  }

  ContextSubscriber.prototype.setDefaultValueGetter = function (fn) {
    this.defaultValueGetter = fn;
  };

  return ContextSubscriber;
}();

exports.ContextSubscriber = ContextSubscriber;

var defaultShallowEquality = function defaultShallowEquality(prev, next) {
  if (prev.length !== next.length) return false;

  for (var i = 0; i < prev.length; i++) {
    if (prev[i] !== next[i]) return false;
  }

  return true;
};